/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Iso_9001Inputs */



/**
* | output |
* | --- |
* | "ISO 9001 certified" |
*
* @param {Footer_Iso_9001Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const footer_iso_9001 = /** @type {((inputs?: Footer_Iso_9001Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Iso_9001Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("ISO 9001 认证")
	return /** @type {LocalizedString} */ ("ISO 9001 certified")
});